import { TbMessageCircle, TbMessageCircleDown, TbMessageCircleUp, TbMessageCircleX, TbPackages } from "react-icons/tb";
import { Col, Row } from "antd";
import { StaticCard } from "./StatisticCard";
import { BulkMessageStatistics } from "../../../hooks/apis/bulkmessages.api";

const BulkMessageStatisticsContainer: React.FC<{ statistics: BulkMessageStatistics | null }> = ({ statistics }) => {
    if (!statistics) {
        statistics = {
            total: 0,
            total_bulk_jobs: 0,
            pending: 0,
            sent: 0,
            failed: 0,
            scheduled: 0
        };
    }

    const statisticFields = [
        {
            title: "Total",
            icon: <TbMessageCircle color="white" size={30} />,
            className: "bnb2",
            value: statistics.total || 0
        },
        {
            title: "Total Jobs",
            icon: <TbPackages color="white" size={30} />,
            className: "bnb2",
            value: statistics.total_bulk_jobs || 0
        },
        {
            title: "Pending",
            icon: <TbMessageCircleDown size={30} />,
            className: "bnb2",
            value: statistics.pending || 0
        },
        {
            title: "Sent",
            icon: <TbMessageCircleUp size={30} />,
            className: "bnb2",
            value: statistics.sent || 0
        },
        {
            title: "Scheduled",
            icon: <TbMessageCircleUp size={30} />,
            className: "bnb2",
            value: statistics.scheduled || 0
        },
        {
            title: "Failed",
            icon: <TbMessageCircleX size={30} />,
            className: "redtext",
            value: statistics.failed || 0
        }
    ];
    return (
        <Row className="rowgap-vbox" gutter={[20, 20]} style={{ width: "100%", margin: "0px" }}>
            {statisticFields.map(field => (
                <Col
                    key={field.title}
                    xs={24}
                    sm={24}
                    md={12}
                    style={{
                        flex: "20%",
                        maxWidth: "20%"
                    }}
                    className="mb-24"
                >
                    <StaticCard title={field.title} value={field.value} className={field.className} icon={field.icon} />
                </Col>
            ))}
        </Row>
    );
};

export default BulkMessageStatisticsContainer;
